export const MSTR_BASE_PATH = "/mstr";

export const mstrPath = (path = "") => {
  if (!path) return MSTR_BASE_PATH;

  return `${MSTR_BASE_PATH}${path.startsWith("/") ? path : `/${path}`}`;
};
